<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <rect width="20" height="18" transform="translate(0 1)" fill="transparent" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 18.991H20V1H0V18.991ZM2.1625 16.7924H17.8375V3.19857H2.1625V16.7924Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 11.3436C9.21813 11.3497 8.45994 11.0678 7.8625 10.549L0.372498 3.91472L1.79125 2.25615L9.2825 8.89043C9.6575 9.22215 10.3412 9.22215 10.7175 8.89043L18.2087 2.25615L19.6287 3.91472L12.1375 10.549C11.5401 11.0678 10.7819 11.3497 10 11.3436Z"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'EmailSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
